"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSyncedBlock = exports.GetPaymentsAndEscrowStateForReceivables = exports.GetAnyToNativePayments = exports.GetAnyToFungiblePayments = exports.GetPaymentsAndEscrowState = exports.GetLastSyncedBlock = exports.EscrowEventResult = exports.PaymentEventResult = exports.getSdk = exports.GetSyncedBlockDocument = exports.GetPaymentsAndEscrowStateForReceivablesDocument = exports.GetAnyToNativePaymentsDocument = exports.GetAnyToFungiblePaymentsDocument = exports.GetPaymentsAndEscrowStateDocument = exports.GetLastSyncedBlockDocument = exports.EscrowEventResultFragmentDoc = exports.PaymentEventResultFragmentDoc = exports._SubgraphErrorPolicy_ = exports.Payment_OrderBy = exports.OrderDirection = exports.EventName = exports.Escrow_OrderBy = exports.EscrowState = exports.EscrowEvent_OrderBy = void 0;
const graphql_tag_1 = require("graphql-tag");
var EscrowEvent_OrderBy;
(function (EscrowEvent_OrderBy) {
    EscrowEvent_OrderBy["Block"] = "block";
    EscrowEvent_OrderBy["ContractAddress"] = "contractAddress";
    EscrowEvent_OrderBy["Escrow"] = "escrow";
    EscrowEvent_OrderBy["EscrowAmount"] = "escrow__amount";
    EscrowEvent_OrderBy["EscrowContractAddress"] = "escrow__contractAddress";
    EscrowEvent_OrderBy["EscrowCreationBlock"] = "escrow__creationBlock";
    EscrowEvent_OrderBy["EscrowCreationTimestamp"] = "escrow__creationTimestamp";
    EscrowEvent_OrderBy["EscrowEscrowState"] = "escrow__escrowState";
    EscrowEvent_OrderBy["EscrowFeeAddress"] = "escrow__feeAddress";
    EscrowEvent_OrderBy["EscrowFeeAmount"] = "escrow__feeAmount";
    EscrowEvent_OrderBy["EscrowFrom"] = "escrow__from";
    EscrowEvent_OrderBy["EscrowId"] = "escrow__id";
    EscrowEvent_OrderBy["EscrowPaymentProxyAddress"] = "escrow__paymentProxyAddress";
    EscrowEvent_OrderBy["EscrowReference"] = "escrow__reference";
    EscrowEvent_OrderBy["EscrowTo"] = "escrow__to";
    EscrowEvent_OrderBy["EscrowTokenAddress"] = "escrow__tokenAddress";
    EscrowEvent_OrderBy["EventName"] = "eventName";
    EscrowEvent_OrderBy["From"] = "from";
    EscrowEvent_OrderBy["GasPrice"] = "gasPrice";
    EscrowEvent_OrderBy["GasUsed"] = "gasUsed";
    EscrowEvent_OrderBy["Id"] = "id";
    EscrowEvent_OrderBy["Reference"] = "reference";
    EscrowEvent_OrderBy["Timestamp"] = "timestamp";
    EscrowEvent_OrderBy["TxHash"] = "txHash";
})(EscrowEvent_OrderBy || (exports.EscrowEvent_OrderBy = EscrowEvent_OrderBy = {}));
var EscrowState;
(function (EscrowState) {
    EscrowState["Emergency"] = "emergency";
    EscrowState["Frozen"] = "frozen";
    EscrowState["PaidEscrow"] = "paidEscrow";
    EscrowState["PaidIssuer"] = "paidIssuer";
})(EscrowState || (exports.EscrowState = EscrowState = {}));
var Escrow_OrderBy;
(function (Escrow_OrderBy) {
    Escrow_OrderBy["Amount"] = "amount";
    Escrow_OrderBy["ContractAddress"] = "contractAddress";
    Escrow_OrderBy["CreationBlock"] = "creationBlock";
    Escrow_OrderBy["CreationTimestamp"] = "creationTimestamp";
    Escrow_OrderBy["EscrowState"] = "escrowState";
    Escrow_OrderBy["Events"] = "events";
    Escrow_OrderBy["FeeAddress"] = "feeAddress";
    Escrow_OrderBy["FeeAmount"] = "feeAmount";
    Escrow_OrderBy["From"] = "from";
    Escrow_OrderBy["Id"] = "id";
    Escrow_OrderBy["PaymentProxyAddress"] = "paymentProxyAddress";
    Escrow_OrderBy["Reference"] = "reference";
    Escrow_OrderBy["To"] = "to";
    Escrow_OrderBy["TokenAddress"] = "tokenAddress";
})(Escrow_OrderBy || (exports.Escrow_OrderBy = Escrow_OrderBy = {}));
var EventName;
(function (EventName) {
    EventName["FreezeEscrow"] = "freezeEscrow";
    EventName["InitiateEmergencyClaim"] = "initiateEmergencyClaim";
    EventName["PaidEscrow"] = "paidEscrow";
    EventName["PaidIssuer"] = "paidIssuer";
    EventName["RevertEmergencyClaim"] = "revertEmergencyClaim";
})(EventName || (exports.EventName = EventName = {}));
/** Defines the order direction, either ascending or descending */
var OrderDirection;
(function (OrderDirection) {
    OrderDirection["Asc"] = "asc";
    OrderDirection["Desc"] = "desc";
})(OrderDirection || (exports.OrderDirection = OrderDirection = {}));
var Payment_OrderBy;
(function (Payment_OrderBy) {
    Payment_OrderBy["Amount"] = "amount";
    Payment_OrderBy["AmountInCrypto"] = "amountInCrypto";
    Payment_OrderBy["Block"] = "block";
    Payment_OrderBy["ContractAddress"] = "contractAddress";
    Payment_OrderBy["Currency"] = "currency";
    Payment_OrderBy["FeeAddress"] = "feeAddress";
    Payment_OrderBy["FeeAmount"] = "feeAmount";
    Payment_OrderBy["FeeAmountInCrypto"] = "feeAmountInCrypto";
    Payment_OrderBy["From"] = "from";
    Payment_OrderBy["GasPrice"] = "gasPrice";
    Payment_OrderBy["GasUsed"] = "gasUsed";
    Payment_OrderBy["Id"] = "id";
    Payment_OrderBy["MaxRateTimespan"] = "maxRateTimespan";
    Payment_OrderBy["Reference"] = "reference";
    Payment_OrderBy["Timestamp"] = "timestamp";
    Payment_OrderBy["To"] = "to";
    Payment_OrderBy["TokenAddress"] = "tokenAddress";
    Payment_OrderBy["TxHash"] = "txHash";
})(Payment_OrderBy || (exports.Payment_OrderBy = Payment_OrderBy = {}));
var _SubgraphErrorPolicy_;
(function (_SubgraphErrorPolicy_) {
    /** Data will be returned even if the subgraph has indexing errors */
    _SubgraphErrorPolicy_["Allow"] = "allow";
    /** If the subgraph has indexing errors, data will be omitted. The default. */
    _SubgraphErrorPolicy_["Deny"] = "deny";
})(_SubgraphErrorPolicy_ || (exports._SubgraphErrorPolicy_ = _SubgraphErrorPolicy_ = {}));
exports.PaymentEventResultFragmentDoc = (0, graphql_tag_1.default) `
    fragment PaymentEventResult on Payment {
  amount
  block
  txHash
  feeAmount
  feeAddress
  from
  gasUsed
  gasPrice
  timestamp
  contractAddress
  to
  tokenAddress
  currency
  amountInCrypto
  feeAmountInCrypto
  maxRateTimespan
}
    `;
exports.EscrowEventResultFragmentDoc = (0, graphql_tag_1.default) `
    fragment EscrowEventResult on EscrowEvent {
  txHash
  eventName
  from
  timestamp
  block
  gasUsed
  gasPrice
}
    `;
exports.GetLastSyncedBlockDocument = (0, graphql_tag_1.default) `
    query GetLastSyncedBlock {
  _meta {
    block {
      number
      hash
    }
  }
}
    `;
exports.GetPaymentsAndEscrowStateDocument = (0, graphql_tag_1.default) `
    query GetPaymentsAndEscrowState($blockFilter: Block_height, $reference: Bytes!, $to: Bytes!, $tokenAddress: Bytes, $contractAddress: Bytes!) {
  payments(
    block: $blockFilter
    where: {reference: $reference, to: $to, contractAddress: $contractAddress, currency: null, tokenAddress: $tokenAddress}
    orderBy: timestamp
    orderDirection: asc
  ) {
    ...PaymentEventResult
  }
  escrowEvents(
    block: $blockFilter
    where: {reference: $reference}
    orderBy: timestamp
    orderDirection: asc
  ) {
    ...EscrowEventResult
  }
}
    ${exports.PaymentEventResultFragmentDoc}
${exports.EscrowEventResultFragmentDoc}`;
exports.GetAnyToFungiblePaymentsDocument = (0, graphql_tag_1.default) `
    query GetAnyToFungiblePayments($blockFilter: Block_height, $reference: Bytes!, $to: Bytes!, $currency: Bytes!, $acceptedTokens: [Bytes!], $contractAddress: Bytes!) {
  payments(
    block: $blockFilter
    where: {reference: $reference, to: $to, currency: $currency, tokenAddress_in: $acceptedTokens, contractAddress: $contractAddress}
    orderBy: timestamp
    orderDirection: asc
  ) {
    ...PaymentEventResult
  }
}
    ${exports.PaymentEventResultFragmentDoc}`;
exports.GetAnyToNativePaymentsDocument = (0, graphql_tag_1.default) `
    query GetAnyToNativePayments($blockFilter: Block_height, $reference: Bytes!, $to: Bytes!, $currency: Bytes!, $contractAddress: Bytes!) {
  payments(
    block: $blockFilter
    where: {reference: $reference, to: $to, currency: $currency, contractAddress: $contractAddress, tokenAddress: null}
    orderBy: timestamp
    orderDirection: asc
  ) {
    ...PaymentEventResult
  }
}
    ${exports.PaymentEventResultFragmentDoc}`;
exports.GetPaymentsAndEscrowStateForReceivablesDocument = (0, graphql_tag_1.default) `
    query GetPaymentsAndEscrowStateForReceivables($blockFilter: Block_height, $reference: Bytes!, $tokenAddress: Bytes!, $contractAddress: Bytes!) {
  payments(
    block: $blockFilter
    where: {reference: $reference, tokenAddress: $tokenAddress, contractAddress: $contractAddress}
    orderBy: timestamp
    orderDirection: asc
  ) {
    ...PaymentEventResult
  }
  escrowEvents(
    block: $blockFilter
    where: {reference: $reference}
    orderBy: timestamp
    orderDirection: asc
  ) {
    ...EscrowEventResult
  }
}
    ${exports.PaymentEventResultFragmentDoc}
${exports.EscrowEventResultFragmentDoc}`;
exports.GetSyncedBlockDocument = (0, graphql_tag_1.default) `
    query GetSyncedBlock($blockHash: Bytes!) {
  _meta(block: {hash: $blockHash}) {
    block {
      number
      hash
    }
  }
}
    `;
const defaultWrapper = (action, _operationName, _operationType) => action();
function getSdk(client, withWrapper = defaultWrapper) {
    return {
        GetLastSyncedBlock(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetLastSyncedBlockDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'GetLastSyncedBlock', 'query');
        },
        GetPaymentsAndEscrowState(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetPaymentsAndEscrowStateDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'GetPaymentsAndEscrowState', 'query');
        },
        GetAnyToFungiblePayments(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetAnyToFungiblePaymentsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'GetAnyToFungiblePayments', 'query');
        },
        GetAnyToNativePayments(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetAnyToNativePaymentsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'GetAnyToNativePayments', 'query');
        },
        GetPaymentsAndEscrowStateForReceivables(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetPaymentsAndEscrowStateForReceivablesDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'GetPaymentsAndEscrowStateForReceivables', 'query');
        },
        GetSyncedBlock(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetSyncedBlockDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'GetSyncedBlock', 'query');
        }
    };
}
exports.getSdk = getSdk;
exports.PaymentEventResult = (0, graphql_tag_1.default) `
    fragment PaymentEventResult on Payment {
  amount
  block
  txHash
  feeAmount
  feeAddress
  from
  gasUsed
  gasPrice
  timestamp
  contractAddress
  to
  tokenAddress
  currency
  amountInCrypto
  feeAmountInCrypto
  maxRateTimespan
}
    `;
exports.EscrowEventResult = (0, graphql_tag_1.default) `
    fragment EscrowEventResult on EscrowEvent {
  txHash
  eventName
  from
  timestamp
  block
  gasUsed
  gasPrice
}
    `;
exports.GetLastSyncedBlock = (0, graphql_tag_1.default) `
    query GetLastSyncedBlock {
  _meta {
    block {
      number
      hash
    }
  }
}
    `;
exports.GetPaymentsAndEscrowState = (0, graphql_tag_1.default) `
    query GetPaymentsAndEscrowState($blockFilter: Block_height, $reference: Bytes!, $to: Bytes!, $tokenAddress: Bytes, $contractAddress: Bytes!) {
  payments(
    block: $blockFilter
    where: {reference: $reference, to: $to, contractAddress: $contractAddress, currency: null, tokenAddress: $tokenAddress}
    orderBy: timestamp
    orderDirection: asc
  ) {
    ...PaymentEventResult
  }
  escrowEvents(
    block: $blockFilter
    where: {reference: $reference}
    orderBy: timestamp
    orderDirection: asc
  ) {
    ...EscrowEventResult
  }
}
    ${exports.PaymentEventResult}
${exports.EscrowEventResult}`;
exports.GetAnyToFungiblePayments = (0, graphql_tag_1.default) `
    query GetAnyToFungiblePayments($blockFilter: Block_height, $reference: Bytes!, $to: Bytes!, $currency: Bytes!, $acceptedTokens: [Bytes!], $contractAddress: Bytes!) {
  payments(
    block: $blockFilter
    where: {reference: $reference, to: $to, currency: $currency, tokenAddress_in: $acceptedTokens, contractAddress: $contractAddress}
    orderBy: timestamp
    orderDirection: asc
  ) {
    ...PaymentEventResult
  }
}
    ${exports.PaymentEventResult}`;
exports.GetAnyToNativePayments = (0, graphql_tag_1.default) `
    query GetAnyToNativePayments($blockFilter: Block_height, $reference: Bytes!, $to: Bytes!, $currency: Bytes!, $contractAddress: Bytes!) {
  payments(
    block: $blockFilter
    where: {reference: $reference, to: $to, currency: $currency, contractAddress: $contractAddress, tokenAddress: null}
    orderBy: timestamp
    orderDirection: asc
  ) {
    ...PaymentEventResult
  }
}
    ${exports.PaymentEventResult}`;
exports.GetPaymentsAndEscrowStateForReceivables = (0, graphql_tag_1.default) `
    query GetPaymentsAndEscrowStateForReceivables($blockFilter: Block_height, $reference: Bytes!, $tokenAddress: Bytes!, $contractAddress: Bytes!) {
  payments(
    block: $blockFilter
    where: {reference: $reference, tokenAddress: $tokenAddress, contractAddress: $contractAddress}
    orderBy: timestamp
    orderDirection: asc
  ) {
    ...PaymentEventResult
  }
  escrowEvents(
    block: $blockFilter
    where: {reference: $reference}
    orderBy: timestamp
    orderDirection: asc
  ) {
    ...EscrowEventResult
  }
}
    ${exports.PaymentEventResult}
${exports.EscrowEventResult}`;
exports.GetSyncedBlock = (0, graphql_tag_1.default) `
    query GetSyncedBlock($blockHash: Bytes!) {
  _meta(block: {hash: $blockHash}) {
    block {
      number
      hash
    }
  }
}
    `;
